import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="section-pad">
      <div className="container-page min-h-[60vh] flex flex-col items-start justify-center">
        <div className="eyebrow">404 — Page not found</div>
        <h1 className="mt-6 font-display text-5xl md:text-7xl leading-[0.95] tracking-tight">
          This page has wandered off<br />into the fog.
        </h1>
        <p className="mt-6 max-w-[56ch] text-[color:var(--text-2)]">
          The link you followed may be dated, moved, or simply never existed.
          Head back to the studio — we’ll show you around.
        </p>
        <Link to="/" className="btn btn-primary mt-10" data-testid="notfound-home-cta">
          Return Home
        </Link>
      </div>
    </section>
  );
}
